/* Vorher/Nachher-Regler — Startseite */
(function () {
  if (window.__hafaBaInit) return;
  window.__hafaBaInit = true;

  function init(ba) {
    if (ba.dataset.baReady) return;
    ba.dataset.baReady = '1';
    var dragging = false;
    function setFromClientX(clientX) {
      var r = ba.getBoundingClientRect();
      var x = Math.min(Math.max((clientX - r.left) / r.width, 0), 1);
      ba.style.setProperty('--pos', (x * 100).toFixed(1) + '%');
      ba.setAttribute('aria-valuenow', Math.round(x * 100));
    }
    ba.addEventListener('pointerdown', function (e) {
      dragging = true;
      ba.setPointerCapture(e.pointerId);
      setFromClientX(e.clientX);
    });
    ba.addEventListener('pointermove', function (e) { if (dragging) setFromClientX(e.clientX); });
    ba.addEventListener('pointerup',     function () { dragging = false; });
    ba.addEventListener('pointercancel', function () { dragging = false; });
    ba.addEventListener('keydown', function (e) {
      var cur = parseFloat(ba.getAttribute('aria-valuenow') || '50');
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft')       cur -= step;
      else if (e.key === 'ArrowRight') cur += step;
      else if (e.key === 'Home')       cur = 0;
      else if (e.key === 'End')        cur = 100;
      else return;
      e.preventDefault();
      cur = Math.min(Math.max(cur, 0), 100);
      ba.style.setProperty('--pos', cur + '%');
      ba.setAttribute('aria-valuenow', Math.round(cur));
    });
  }

  function scan() { document.querySelectorAll('.hafa-ba').forEach(init); }
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
